import { useState, useEffect, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getConstants } from 'utils/constants';

const { LANGUAGE_STORAGE_KEY, LANGUAGE_DEFAULT } = getConstants();

export function useLang() {
  const { i18n } = useTranslation();

  const [lang, setLangState] = useState<string>(() => {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY) || LANGUAGE_DEFAULT;
  });

  // Hàm setLang có ghi vào localStorage
  const setLang = useCallback((newLang: string) => {
    setLangState(newLang);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, newLang);
    i18n.changeLanguage(newLang);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const handleStorage = (e: StorageEvent) => {
      if (e.key === LANGUAGE_STORAGE_KEY && e.newValue) {
        setLangState(e.newValue);
      }
    };
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  return { lang, setLang };
}
